import { Node, mergeAttributes } from '@tiptap/core';
export const ASSET_LINK_LIST_NAME = 'assetLinkList';
export const ASSET_LINK_LIST_ITEM_NAME = 'assetLinkListItem';
const ASSET_LINK_LIST_ITEM_TAG_NAME = 'mb-asset-link-list-item';
export const AssetLinkListItem = Node.create({
    name: ASSET_LINK_LIST_ITEM_NAME,
    group: ASSET_LINK_LIST_NAME,
    content: 'text*',
    marks: '_',
    isolating: true,
    draggable: true,
    addAttributes() {
        return {
            link: {
                default: '',
                renderHTML(attrs) {
                    return { 'data-link': attrs.link };
                },
                parseHTML(element) {
                    const link = element.getAttribute('data-link') ?? '';
                    return link;
                },
            },
        };
    },
    addCommands() {
        return {
            addAssetLinkItemItem: () => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: {
                        link: '',
                    },
                });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: ASSET_LINK_LIST_ITEM_TAG_NAME,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            ASSET_LINK_LIST_ITEM_TAG_NAME,
            mergeAttributes(HTMLAttributes),
            ['div', ['a', { href: HTMLAttributes['data-link'] }, 'Link'], ['p', 0]],
        ];
    },
});
const TAG_NAME = 'mb-asset-link-list';
export const AssetLinkList = Node.create({
    name: ASSET_LINK_LIST_NAME,
    group: 'block',
    content: `${ASSET_LINK_LIST_ITEM_NAME}*`,
    atom: true,
    draggable: true,
    addOptions() {
        return {
            tagName: TAG_NAME,
        };
    },
    addCommands() {
        return {
            addAssetLinkList: () => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    content: [
                        {
                            type: ASSET_LINK_LIST_ITEM_NAME,
                            attrs: { link: '' },
                        },
                        {
                            type: ASSET_LINK_LIST_ITEM_NAME,
                            attrs: { link: '' },
                        },
                    ],
                });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: this.options.tagName,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [this.options.tagName, mergeAttributes(HTMLAttributes), 0];
    },
});
//# sourceMappingURL=asset-link-list.js.map